import React, { HTMLProps } from 'react';

type LinkProps = {
  renderAnchor?: boolean;
};

export const Link: React.FunctionComponent<HTMLProps<HTMLAnchorElement> &
  LinkProps> = ({ children, renderAnchor = true, ...props }) => {
  if (renderAnchor) {
    return <a {...props}>{children}</a>;
  }

  return <span className={props.className}>{children}</span>;
};
